import styled from 'styled-components';
import { TransparentButton } from '../../../__core/Styles/Buttons/TransparentButton';

export const NavBar = styled.header`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3rem 0 3rem;
  color: ${({ theme }) => theme.UI_COLORS.light};
  background-color: ${({ theme }) => theme.UI_COLORS.secondary};
  box-sizing: border-box;
  z-index: 10;
  position: fixed;
  right: 0;
  left: 0;
  width: 100%;
`;

export const CorporateLogo = styled.div`
  width: 124px;
`;

export const UserMenu = styled.div`
  display: flex;
  align-items: center;

  a {
    text-decoration: none;
  }
`;

export const UserMenuLinkItem = styled.div`
  display: none;

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    display: block;
    margin-right: 2rem;
  }

  @media (${({ theme }) => theme.MEDIA_MIN.laptop}) {
    margin-right: 4rem;
  }

  a {
    color: ${({ theme }) => theme.UI_COLORS.light};
    text-decoration: none;
    font-size: ${({ theme }) => theme.TYPOGRAPHY.label.fontSize};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color ease-in-out 0.3s;

    &:hover,
    &.active {
      color: ${({ theme }) => theme.UI_COLORS.primary};
    }

    svg {
      margin-right: 1rem;
      fill: ${({ theme }) => theme.UI_COLORS.primary};
      width: 18px;
    }
  }
`;

export const LogoutButton = styled(TransparentButton)`
  border: 1px solid ${({ theme }) => theme.COLORS.buttonBorderDark};
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 100px;
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  text-decoration: none;

  svg {
    margin-right: 1.2rem;
    font-size: ${({ theme }) => theme.FONT_SIZES.secondary};
  }
`;

export const SearchPortal = styled.div`
  position: relative;
`;

export const UserProfilePopOver = styled.div`
  width: 350px;
  padding: 1rem 1rem 0 1rem;

  & > div.profile-header {
    display: flex;
    justify-content: space-between;
    font-size: 2rem;
    font-weight: bold;
    padding: 2rem 2.5rem 0 2.5rem;
  }
`;

export const LogoutSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & > a {
    margin-bottom: 1.5rem;
  }
`;

export const NavbarIcon = styled.span`
  margin-left: 4rem;
  svg {
    fill: ${({ theme }) => theme.UI_COLORS.primary};
    cursor: pointer;
  }
`;

export const DesktopMenu = styled.div`
  display: none;
  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    display: block;
  }
`;
